export enum PAYMENT_TRANSACTION_STATUS {
  CREATED = "created",
  PENDING = "pending",
  PAID = "paid",
  FAILED = "failed",
  EXPIRED = "expired",
  CANCELLED = "cancelled",
}
